export enum RegistrationQueryParams {
  ModelNumber = 'mn',
  SerialNumber = 'sn',
  RegistrationSource = 'rs',
  UserToken = 'ut',
}
